<dx-tag-box
  [value]="value()"
  [valueExpr]="valueExpr()"
  [displayExpr]="displayExpr()"
  [dataSource]="dataSource() ?? null"
  [searchEnabled]="searchEnabled()"
  [tagTemplate]="tagTemplate()"
  [acceptCustomValue]="acceptCustomValue()"
  [placeholder]="placeholder() ?? ''"
  [customItemCreateEvent]="customItemCreateEvent()"
  (onValueChanged)="onValueChangedInternal($event)"
  (onCustomItemCreating)="onCustomItemCreating.emit($event)"
></dx-tag-box>
